import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

/* A pie chart that shows all of the metrics, generally by crop for a specific year. */
const MetricsPieChart = ({ data, metrics }) => {
  const pieData = metrics
    .map(({ accessor, color, displayName }) => ({
      value: data[0][accessor],
      color,
      accessor,
      displayName,
    }))
    .filter(({ value }) => value > 0);

  return (
    <ResponsiveContainer width="99%" height="99%">
      <PieChart width={200} height={200}>
        <Pie
          data={pieData}
          outerRadius="78%"
          fill="#8884d8"
          dataKey="value"
          label={(entry) => entry.displayName}
          animationDuration={0}
          isAnimationActive={false}
        >
          {pieData.map(({ accessor, color }) => (
            <Cell key={accessor} fill={color} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default MetricsPieChart;
